<!-- 贸易AI助手：选择目的国 + 上传Excel，一次请求返回全部票，按票页签展示申报建议表格 -->
<template>
    <div class="gw-ai-wrap">
        <!-- 顶部标题 -->
        <div class="gw-ai-header">
            <div class="gw-ai-title">
                <span class="gw-ai-dot"></span>
                <span>贸易AI助手</span>
            </div>
            <span class="gw-ai-sub">选择目的国并上传Excel，AI将按票分页签返回申报建议</span>
        </div>
        <!-- 消息区 -->
        <div class="gw-ai-body" ref="msgBody">
            <!-- 空状态 -->
            <div class="gw-ai-empty" v-if="messages.length === 0">
                <i class="el-icon-chat-dot-round"></i>
                <p>请选择目的国并上传 Excel 文件后发送</p>
                <span>AI 将以表格方式返回商品申报建议</span>
            </div>
            <div v-for="(msg, index) in messages" :key="index">
                <!-- 用户消息 -->
                <div class="gw-msg-row gw-msg-user" v-if="msg.role === 'user'">
                    <div class="gw-avatar gw-avatar-user">我</div>
                    <div class="gw-bubble gw-bubble-user">
                        <span class="gw-pill"><i class="el-icon-location-outline"></i>目的国：{{ msg.country }}</span>
                        <span class="gw-pill"><i class="el-icon-document"></i>{{ msg.fileName }}</span>
                    </div>
                </div>
                <!-- AI消息 -->
                <div class="gw-msg-row" v-else>
                    <div class="gw-avatar">AI</div>
                    <div class="gw-bubble gw-bubble-ai">
                        <!-- 解析中 -->
                        <div class="gw-ai-loading" v-if="msg.loading">
                            <i class="el-icon-loading"></i><span>{{ msg.text }}</span>
                        </div>
                        <!-- 失败/提示 -->
                        <div class="gw-ai-error" v-else-if="msg.error">
                            <i class="el-icon-warning-outline"></i><span>{{ msg.text }}</span>
                        </div>
                        <!-- 结果：按票（页签）展示表格 -->
                        <template v-else>
                            <div class="gw-ai-text-row">
                                <p class="gw-ai-text">已解析Excel（{{ msg.totalTickets }} 个页签，共 {{ msg.totalRows }} 行商品），以下为目的国「{{ msg.country }}」的申报建议：</p>
                                <el-button size="mini" plain icon="el-icon-download" :loading="exporting" @click="exportExcel(msg)">导出Excel</el-button>
                            </div>
                            <!-- 归档结果：保存用户数据后后端生成的批次号（数组） -->
                            <div v-if="msg.archiveSaved" class="gw-archive-tip">
                                <i class="el-icon-circle-check gw-archive-icon"></i>
                                <div class="gw-archive-body">
                                    <div class="gw-archive-head">
                                        <span class="gw-archive-title">已生成以下归档批次</span>
                                        <span class="gw-archive-count" v-if="msg.archiveBatchNos && msg.archiveBatchNos.length">共 {{ msg.archiveBatchNos.length }} 个</span>
                                    </div>
                                    <div class="gw-archive-list" v-if="msg.archiveBatchNos && msg.archiveBatchNos.length">
                                        <span class="gw-archive-chip" v-for="(no, index) in msg.archiveBatchNos" :key="index">{{ no }}</span>
                                    </div>
                                    <div class="gw-archive-empty" v-else>接口未返回批次号</div>
                                </div>
                            </div>
                            <div v-if="msg.archiveDuplicate" class="gw-archive-tip">
                                <div class="gw-archive-empty">归档记录已存在</div>
                            </div>
                            <!-- 接口级提示，如页签序号回退/重复 -->
                            <el-alert v-if="msg.warnings && msg.warnings.length" class="gw-ai-alert" type="warning"
                                :closable="false" show-icon :title="warningsText(msg.warnings)"></el-alert>
                            <el-tabs v-model="msg.activeTab" class="gw-ai-tabs">
                                <el-tab-pane v-for="ticket in msg.tickets" :key="ticket.key" :name="ticket.key"
                                    :label="tabLabel(ticket)">
                                    <el-table :data="ticket.rows" border size="mini" class="gw-ai-table" :row-class-name="rowClassName">
                                        <el-table-column type="expand" width="34">
                                            <template slot-scope="props">
                                                <div class="gw-expand-box">
                                                    <template v-if="props.row.success">
                                                        <div class="gw-expand-item">
                                                            <label>出口申报要素：</label>
                                                            <div class="gw-element">{{ getVal(props.row.exportSuggest, 'cnElement') }}</div>
                                                        </div>
                                                        <div class="gw-expand-item">
                                                            <label>出口备注：</label><span>{{ getVal(props.row.exportSuggest, 'note') }}</span>
                                                        </div>
                                                        <div class="gw-expand-item">
                                                            <label>出口申报批次（共 {{ (props.row.exportSuggest && props.row.exportSuggest.batchTotal) || 0 }} 票）：</label>
                                                            <span>{{ batchText(props.row.exportSuggest && props.row.exportSuggest.batchNos) }}</span>
                                                        </div>
                                                        <div class="gw-expand-item">
                                                            <label>进口申报要素：</label>
                                                            <div class="gw-element">{{ getVal(props.row.importSuggest, 'localElement') }}</div>
                                                        </div>
                                                        <div class="gw-expand-item">
                                                            <label>进口申报批次（共 {{ (props.row.importSuggest && props.row.importSuggest.batchTotal) || 0 }} 票）：</label>
                                                            <span>{{ batchText(props.row.importSuggest && props.row.importSuggest.batchNos) }}</span>
                                                        </div>
                                                        <div class="gw-expand-item" v-if="props.row.warnings && props.row.warnings.length">
                                                            <label>风险提示：</label>
                                                            <div class="gw-warn" v-for="(w, wi) in props.row.warnings" :key="wi">{{ w }}</div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="gw-expand-item">
                                                            <label>失败原因：</label><span class="gw-warn">{{ props.row.errorMsg || '-' }}</span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rowNo" label="序号" width="55" align="center" :formatter="fmt"></el-table-column>
                                        <el-table-column label="出口HS编码" width="100" align="center">
                                            <template slot-scope="scope">{{ getVal(scope.row.exportSuggest, 'cnHsCode') }}</template>
                                        </el-table-column>
                                        <el-table-column prop="name" label="品名" min-width="120" show-overflow-tooltip :formatter="fmt"></el-table-column>
                                        <el-table-column prop="matchLayer" label="出口匹配" width="70" align="center" :formatter="fmt"></el-table-column>
                                        <el-table-column prop="confidence" label="出口置信度" width="90" align="center" :formatter="fmt"></el-table-column>
                                        <el-table-column label="进口HS编码" width="100" align="center">
                                            <template slot-scope="scope">{{ getVal(scope.row.importSuggest, 'hsCode') }}</template>
                                        </el-table-column>
                                        <el-table-column label="进口英文名" min-width="110" show-overflow-tooltip>
                                            <template slot-scope="scope">{{ getVal(scope.row.importSuggest, 'engName') }}</template>
                                        </el-table-column>
                                        <el-table-column prop="importMatchLayer" label="进口匹配" width="70" align="center" :formatter="fmt"></el-table-column>
                                        <el-table-column prop="importConfidence" label="进口置信度" width="90" align="center" :formatter="fmt"></el-table-column>
                                        <el-table-column label="状态" width="70" align="center">
                                            <template slot-scope="scope">
                                                <el-tooltip v-if="scope.row.success === false" :content="scope.row.errorMsg || '解析失败'" placement="top">
                                                    <el-tag type="danger" size="mini">失败</el-tag>
                                                </el-tooltip>
                                                <el-tag v-else type="success" size="mini">成功</el-tag>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部操作区：无文字输入，仅目的国 + 上传Excel + 发送 -->
        <div class="gw-ai-footer">
            <el-select v-model="country" filterable size="small" placeholder="请选择目的国(地区)" class="gw-country-select" :disabled="sending"
            remote :remote-method="getCountryList">
                <el-option v-for="item in countryList" :key="item.codeValue + '-' + item.cusCode" :label="item.codeName" :value="item.codeName">
                    <span class="gw-opt-code">{{ item.codeValue }}</span>
                    <span class="gw-opt-name">{{ item.codeName }}</span>
                    <span>{{ item.cusCode }}</span>
                </el-option>
            </el-select>
            <!-- 是否保存用户数据：与底部下拉框、按钮同高的分组设置项 -->
            <div class="gw-save-box">
                <span class="gw-save-label">是否保存用户数据</span>
                <el-radio-group v-model="saveValue" class="gw-save-radio" aria-label="是否保存用户数据">
                    <el-radio :label="true">保存</el-radio>
                    <el-radio :label="false">不保存</el-radio>
                </el-radio-group>
            </div>
            <el-upload ref="excelUpload" action="#" accept=".xlsx,.xls" :auto-upload="false" :show-file-list="false"
                :on-change="onFileChange" :disabled="sending">
                <el-button size="small" icon="el-icon-upload2" :disabled="sending">上传Excel</el-button>
            </el-upload>
            <!-- 已选文件 -->
            <div class="gw-file-chip" v-if="file">
                <i class="el-icon-document"></i>
                <span class="gw-file-name">{{ file.name }}</span>
                <i class="el-icon-close" v-if="!sending" @click="removeFile"></i>
            </div>
            <div class="gw-footer-flex"></div>
            <el-button type="primary" size="small" icon="el-icon-s-promotion" :loading="sending" @click="sendMessage">发送</el-button>
        </div>
    </div>
</template>

<script>
import ExcelJS from 'exceljs'
import AEObasicData from '@/config/AEObasicData.js'
export default {
    name: 'gwAIAssistant',
    data() {
        return {
            // 目的国数据源：与出口报关单表体「最终目的国」一致
            countryList: AEObasicData.CUS_MAPPING_COUNTRY_CODE_V,
            // 选中的目的国（codeName 汉字）
            country: '',
            // 已选Excel文件 { name, raw }
            file: null,
            // 是否发送中
            sending: false,
            // 是否正在导出Excel
            exporting: false,
            // 是否保存用户数据
            saveValue:false,
            // 消息列表
            // { role:'user', country, fileName } 用户消息
            // { role:'ai', loading:true, text } 解析中
            // { role:'ai', error:true, text } 失败/提示
            // { role:'ai', country, tickets:[{key,ticket,sheetName,rows}], totalTickets, totalRows, warnings, activeTab, archiveSaved, archiveDuplicate, archiveBatchNos } 建议结果（按票分页签）
            messages: [],
        }
    },
    watch: {
        // 只在新消息入列时滚动到底部；不要 deep，避免切换页签时被拽回底部
        'messages.length'() {
            this.scrollBottom()
        },
    },
    methods: {
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 选择Excel文件
        onFileChange(file) {
            const name = file.name || ''
            if (!/\.(xlsx|xls)$/i.test(name)) {
                this.$message.error('仅支持上传 .xlsx / .xls 格式的Excel文件')
                this.$refs.excelUpload.clearFiles()
                return
            }
            this.file = { name: name, raw: file.raw }
        },
        // 移除已选文件
        removeFile() {
            this.file = null
            this.$refs.excelUpload.clearFiles()
        },
        // 发送：只调一个接口（tradeai/suggest/excel），一次返回全部票（页签）
        sendMessage() {
            if (this.sending) return
            if (!this.country) {
                this.$message.warning('请先选择目的国')
                return
            }
            if (!this.file) {
                this.$message.warning('请先上传Excel文件')
                return
            }
            const country = this.country
            const file = this.file
            // 用户消息入列
            this.messages.push({ role: 'user', country: country, fileName: file.name })
            // AI解析中提示
            const loadingMsg = { role: 'ai', loading: true, text: '正在解析Excel并生成申报建议，请稍候...' }
            this.messages.push(loadingMsg)
            // 清空输入
            this.country = ''
            this.removeFile()
            this.sending = true
            // 上传Excel，解析与建议由后端一次返回；目的国走 query，文件走 form-data
            const formData = new FormData()
            formData.append('file', file.raw)
            this.$api.tradeaiSuggestExcel({ country: country,save:this.saveValue }, formData).then(res => {
                const tickets = this.buildTickets(res)
                if (!tickets.length) {
                    this.replaceMsg(loadingMsg, { role: 'ai', error: true, text: '未解析到有效数据，请检查Excel内容后重试' })
                    return
                }
                this.replaceMsg(loadingMsg, {
                    role: 'ai',
                    country: country,
                    tickets: tickets,
                    totalTickets: (res && res.totalTickets) || tickets.length,
                    totalRows: (res && res.totalRows) || tickets.reduce((n, t) => n + t.rows.length, 0),
                    warnings: (res && res.warnings) || [],
                    // 保存用户数据后的归档结果（批次号为数组）
                    archiveSaved: !!(res && res.archiveSaved),
                    archiveDuplicate: !!(res && res.archiveDuplicate),
                    archiveBatchNos: this.toTextArray(res && res.archiveBatchNos),
                    activeTab: tickets[0].key,
                })
            }).catch(() => {
                this.replaceMsg(loadingMsg, { role: 'ai', error: true, text: '解析失败，请稍后重试' })
            }).finally(() => {
                this.sending = false
            })
        },
        // 把接口返回的 tickets 转成页面用的页签数据
        buildTickets(res) {
            const list = (res && res.tickets) || []
            return list.map((ticket, index) => ({
                // 页签唯一标识：票号可能重复，用下标更稳
                key: 'tab-' + index,
                ticket: (ticket && ticket.ticket) || String(index + 1),
                sheetName: (ticket && ticket.sheetName) || ('页签' + (index + 1)),
                rows: ((ticket && ticket.rows) || []).map(item => this.normalizeRow(item)),
            }))
        },
        // rows 元素为 { input, result }，表格统一用 result，个别行没返回 result 时降级为失败行
        normalizeRow(item) {
            const result = item && item.result
            if (!result) {
                const input = (item && item.input) || {}
                return { rowNo: input.rowNo, name: input.name, success: false, errorMsg: '接口未返回该行解析结果' }
            }
            return Object.assign({}, result, { input: (item && item.input) || null })
        },
        // 页签标题：页签名 + 行数
        tabLabel(ticket) {
            const count = (ticket.rows && ticket.rows.length) || 0
            return count ? `${ticket.sheetName}（${count} 行）` : ticket.sheetName
        },
        // 接口级提示文案
        warningsText(list) {
            return list && list.length ? list.join('；') : ''
        },
        // 批次号归一化：兼容接口返回数组 / 单值 / 空值
        toTextArray(value) {
            if (!value) return []
            const list = Array.isArray(value) ? value : [value]
            return list.filter(item => item !== null && item !== undefined && item !== '')
        },
        // 替换loading消息为结果
        replaceMsg(oldMsg, newMsg) {
            const idx = this.messages.indexOf(oldMsg)
            if (idx > -1) {
                this.messages.splice(idx, 1, newMsg)
            }
        },
        // 滚动到底部
        scrollBottom() {
            this.$nextTick(() => {
                const el = this.$refs.msgBody
                if (el) el.scrollTop = el.scrollHeight
            })
        },
        // 失败行标红
        rowClassName({ row }) {
            return row.success === false ? 'gw-row-fail' : ''
        },
        // 取嵌套属性，空值显示'-'
        getVal(obj, key) {
            const v = obj && obj[key]
            return v === null || v === undefined || v === '' ? '-' : v
        },
        // el-table formatter，空值显示'-'
        fmt(row, column, cellValue) {
            return cellValue === null || cellValue === undefined || cellValue === '' ? '-' : cellValue
        },
        // 批次数组转展示文本
        batchText(list) {
            return list && list.length ? list.join('、') : '-'
        },
        // 导出当前消息的全部页签：一个页签一个 sheet
        async exportExcel(msg) {
            const tickets = (msg && msg.tickets) || []
            const total = tickets.reduce((n, t) => n + ((t.rows && t.rows.length) || 0), 0)
            if (total === 0) {
                this.$message.warning('当前没有可导出的数据')
                return
            }
            if (this.exporting) return
            this.exporting = true
            try {
                const workbook = new ExcelJS.Workbook()
                const usedNames = {}
                tickets.forEach((ticket, index) => {
                    const rows = ticket.rows || []
                    if (rows.length === 0) return
                    const worksheet = workbook.addWorksheet(this.safeSheetName(ticket.sheetName, index, usedNames))
                    this.fillSheet(worksheet, rows)
                })
                const buffer = await workbook.xlsx.writeBuffer()
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = this.exportFileName(msg.country)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            } catch (e) {
                this.$message.error('导出失败，请稍后重试')
            } finally {
                this.exporting = false
            }
        },
        // 写入单个页签：列宽、表头加粗、逐行数据
        fillSheet(worksheet, rows) {
            // 列定义：与页面表格可见列一致，并附加展开行中的申报要素/批次/风险提示
            worksheet.columns = [
                { header: '序号', key: 'rowNo', width: 8 },
                { header: '出口HS编码', key: 'cnHsCode', width: 16 },
                { header: '品名', key: 'name', width: 22 },
                { header: '出口匹配', key: 'matchLayer', width: 10 },
                { header: '出口置信度', key: 'confidence', width: 12 },
                { header: '进口HS编码', key: 'hsCode', width: 16 },
                { header: '进口英文名', key: 'engName', width: 22 },
                { header: '进口匹配', key: 'importMatchLayer', width: 10 },
                { header: '进口置信度', key: 'importConfidence', width: 12 },
                { header: '状态', key: 'status', width: 8 },
                { header: '失败原因', key: 'errorMsg', width: 26, style: { alignment: { vertical: 'middle', wrapText: true } } },
                { header: '出口申报要素', key: 'cnElement', width: 36, style: { alignment: { vertical: 'middle', wrapText: true } } },
                { header: '出口备注', key: 'note', width: 22, style: { alignment: { vertical: 'middle', wrapText: true } } },
                { header: '出口申报批次（票数）', key: 'cnBatchTotal', width: 14 },
                { header: '出口申报批次', key: 'cnBatchNos', width: 24 },
                { header: '进口申报要素', key: 'localElement', width: 36, style: { alignment: { vertical: 'middle', wrapText: true } } },
                { header: '进口申报批次（票数）', key: 'localBatchTotal', width: 14 },
                { header: '进口申报批次', key: 'localBatchNos', width: 24 },
                { header: '风险提示', key: 'warnings', width: 30, style: { alignment: { vertical: 'middle', wrapText: true } } },
            ]
            // 表头加粗
            worksheet.getRow(1).font = { bold: true }
            // 逐行写入数据
            rows.forEach(row => {
                worksheet.addRow(this.buildExportRow(row))
            })
        },
        // sheet 名：去掉Excel非法字符、截断到31字符、重名自动加序号
        safeSheetName(name, index, used) {
            let base = String(name || '').replace(/[\\/:*?\[\]]/g, '').trim() || ('页签' + (index + 1))
            base = base.slice(0, 31)
            let result = base
            let seq = 2
            while (used[result]) {
                const suffix = '(' + seq + ')'
                result = base.slice(0, 31 - suffix.length) + suffix
                seq++
            }
            used[result] = true
            return result
        },
        // 组装导出行：字段与页面表格取值保持一致，空值同样显示'-'
        buildExportRow(row) {
            const exportSuggest = row.exportSuggest || {}
            const importSuggest = row.importSuggest || {}
            const failed = row.success === false
            return {
                rowNo: this.getVal(row, 'rowNo'),
                cnHsCode: this.getVal(exportSuggest, 'cnHsCode'),
                name: this.getVal(row, 'name'),
                matchLayer: this.getVal(row, 'matchLayer'),
                confidence: this.getVal(row, 'confidence'),
                hsCode: this.getVal(importSuggest, 'hsCode'),
                engName: this.getVal(importSuggest, 'engName'),
                importMatchLayer: this.getVal(row, 'importMatchLayer'),
                importConfidence: this.getVal(row, 'importConfidence'),
                status: failed ? '失败' : '成功',
                errorMsg: failed ? this.getVal(row, 'errorMsg') : '-',
                cnElement: this.getVal(exportSuggest, 'cnElement'),
                note: this.getVal(exportSuggest, 'note'),
                cnBatchTotal: exportSuggest.batchTotal === null || exportSuggest.batchTotal === undefined ? '-' : exportSuggest.batchTotal,
                cnBatchNos: this.batchText(exportSuggest.batchNos),
                localElement: this.getVal(importSuggest, 'localElement'),
                localBatchTotal: importSuggest.batchTotal === null || importSuggest.batchTotal === undefined ? '-' : importSuggest.batchTotal,
                localBatchNos: this.batchText(importSuggest.batchNos),
                warnings: row.warnings && row.warnings.length ? row.warnings.join('；') : '-',
            }
        },
        // 导出文件名：贸易AI助手_申报建议_目的国_时间戳.xlsx
        exportFileName(country) {
            const now = new Date()
            const pad = n => String(n).padStart(2, '0')
            const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
            // 目的国可能含文件名非法字符，去掉后再拼接
            const safeCountry = String(country || '').replace(/[\\/:*?"<>|]/g, '')
            return `贸易AI助手_申报建议${safeCountry ? '_' + safeCountry : ''}_${timestamp}.xlsx`
        },
    },
}
</script>

<style lang="css" scoped>
.gw-ai-wrap {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 86px);
    min-height: 480px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    overflow: hidden;
}
/* 顶部 */
.gw-ai-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
}
.gw-ai-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}
.gw-ai-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #67c23a;
    margin-right: 8px;
}
.gw-ai-sub {
    font-size: 12px;
    color: #909399;
}
/* 消息区 */
.gw-ai-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    background: #f7f8fa;
}
.gw-ai-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
}
.gw-ai-empty i {
    font-size: 48px;
    margin-bottom: 12px;
}
.gw-ai-empty p {
    margin: 0 0 4px;
    font-size: 14px;
}
.gw-ai-empty span {
    font-size: 12px;
}
.gw-msg-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
}
.gw-msg-user {
    flex-direction: row-reverse;
}
.gw-avatar {
    flex: none;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #67c23a;
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.gw-avatar-user {
    background: #909399;
}
.gw-bubble {
    max-width: 85%;
    padding: 10px 12px;
    border-radius: 8px;
}
.gw-bubble-user {
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}
.gw-bubble-ai {
    background: #fff;
    border: 1px solid #ebeef5;
    /* 结果区是页签+宽表格，占满头像以外的剩余宽度 */
    max-width: calc(100% - 34px);
}
.gw-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 10px;
    border: 1px solid #67c23a;
    border-radius: 999px;
    font-size: 12px;
    line-height: 20px;
    color: #529b2e;
}
.gw-ai-text {
    margin: 0 0 8px;
    font-size: 14px;
    color: #303133;
}
/* 结果标题行：左侧说明 + 右侧导出按钮 */
.gw-ai-text-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}
.gw-ai-text-row .gw-ai-text {
    margin: 0;
}
/* 接口级提示（页签序号回退/重复等） */
.gw-ai-alert {
    margin-bottom: 8px;
}
.gw-ai-alert ::v-deep .el-alert__title {
    font-size: 12px;
    line-height: 18px;
}
/* 归档结果：批次号数组做成可换行的号码胶囊 */
.gw-archive-tip {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    padding: 8px 12px;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    background: #f0f9eb;
}
.gw-archive-icon {
    margin-top: 2px;
    font-size: 14px;
    line-height: 1;
    color: #67c23a;
}
.gw-archive-body {
    flex: 1;
    min-width: 0;
}
.gw-archive-head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 12px;
    line-height: 20px;
}
.gw-archive-title {
    font-weight: 600;
    color: #303133;
}
.gw-archive-count {
    color: #909399;
}
.gw-archive-dup {
    color: #e6a23c;
}
.gw-archive-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
}
.gw-archive-chip {
    padding: 0 8px;
    border: 1px solid #c2e7b0;
    border-radius: 3px;
    background: #fff;
    color: #3f7d22;
    font-family: Consolas, Monaco, 'Courier New', monospace;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
}
.gw-archive-empty {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
}
/* 结果页签 */
.gw-ai-tabs ::v-deep .el-tabs__header {
    margin-bottom: 8px;
}
.gw-ai-tabs ::v-deep .el-tabs__item {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
}
.gw-ai-loading,
.gw-ai-error {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #303133;
}
.gw-ai-loading i {
    color: #67c23a;
}
.gw-ai-error,
.gw-ai-error i {
    color: #f56c6c;
}
/* AI表格 */
.gw-ai-table {
    width: 100%;
}
.gw-ai-table ::v-deep .gw-row-fail {
    background: #fef0f0;
}
.gw-expand-box {
    padding: 4px 24px 8px 48px;
}
.gw-expand-item {
    margin-bottom: 6px;
    font-size: 12px;
    line-height: 20px;
    color: #606266;
}
.gw-expand-item label {
    color: #909399;
    margin-right: 4px;
}
.gw-element {
    white-space: pre-wrap;
    color: #303133;
    background: #f7f8fa;
    padding: 6px 10px;
    border-radius: 4px;
    margin-top: 4px;
}
.gw-warn {
    color: #e6a23c;
}
/* 底部操作区 */
.gw-ai-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-top: 1px solid #ebeef5;
    background: #fff;
}
.gw-country-select {
    width: 220px;
}
.gw-opt-code {
    margin-right: 16px;
    color: #909399;
}
.gw-opt-name {
    margin-right: 16px;
}
/* 是否保存用户数据：分组设置项，与 small 尺寸控件同高 */
.gw-save-box {
    flex: none;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #f5f7fa;
    transition: border-color 0.2s;
}
.gw-save-box:hover {
    border-color: #c0c4cc;
}
.gw-save-label {
    font-size: 12px;
    color: #606266;
    white-space: nowrap;
}
.gw-save-radio {
    display: inline-flex;
    align-items: center;
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #e4e7ed;
}
.gw-save-radio ::v-deep .el-radio {
    margin-right: 12px;
    line-height: 1;
}
.gw-save-radio ::v-deep .el-radio:last-child {
    margin-right: 0;
}
.gw-save-radio ::v-deep .el-radio__label {
    font-size: 12px;
    padding-left: 6px;
}
.gw-file-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 999px;
    background: #f4f4f5;
    font-size: 12px;
    color: #606266;
    max-width: 260px;
}
.gw-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.gw-file-chip .el-icon-close {
    cursor: pointer;
    color: #909399;
}
.gw-file-chip .el-icon-close:hover {
    color: #f56c6c;
}
.gw-footer-flex {
    flex: 1;
}
</style>
